// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__1QTYB","notes":"Notes_notes__17azg"};